// extracted by mini-css-extract-plugin
export default {"root":"variants_root__DPwt-","table-btn-container":"variants_table-btn-container__CjG2Q","add-btn":"variants_add-btn__jBFlz"};